import React from 'react';
import { Info } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const TEXTS = {
  de: {
    title: 'Massgebliche Sprachfassung',
    body: 'Rechtlich verbindlich ist ausschliesslich die deutsche Originalfassung dieses Dokuments. Übersetzungen werden zur Information bereitgestellt und können von der deutschen Fassung abweichen.',
  },
  en: {
    title: 'Authoritative language version',
    body: 'Only the German original version of this document is legally binding. Translations are provided for informational purposes and may deviate from the German version.',
  },
  ru: {
    title: 'Юридически значимая языковая версия',
    body: 'Юридически обязательной является исключительно немецкая оригинальная версия данного документа. Переводы предоставляются в информационных целях и могут отличаться от немецкой версии.',
  },
  vi: {
    title: 'Bản ngôn ngữ có giá trị pháp lý',
    body: 'Chỉ bản gốc tiếng Đức của tài liệu này có giá trị pháp lý. Các bản dịch chỉ được cung cấp để tham khảo và có thể khác với bản tiếng Đức.',
  },
};

export const LegalLanguageBanner = () => {
  const { language } = useLanguage();
  if (language === 'de') return null;
  const t = TEXTS[language] || TEXTS.en;
  return (
    <div
      data-testid="legal-language-banner"
      className="bg-amber-500/10 border border-amber-500/30 rounded-xl p-4 md:p-5 mb-6 flex items-start gap-3"
    >
      <Info className="h-5 w-5 text-amber-300 mt-0.5 shrink-0" />
      <div>
        <div className="text-amber-200 font-semibold mb-1">{t.title}</div>
        <p className="text-amber-100/80 text-sm leading-relaxed">{t.body}</p>
      </div>
    </div>
  );
};
